import timg1 from "../images/teams/img-1.jpg";
import timg2 from "../images/teams/img-2.jpg";
import timg3 from "../images/teams/img-3.jpg";
import timg4 from "../images/teams/img-4.jpg";

export interface TeamMember {
  id: string;
  tImg: string;
  name: string;
  slug: string;
  title: string;
}

const Teams: TeamMember[] = [
  {
    id: "1",
    tImg: timg1,
    name: "허상훈 (Heo Sanghoon)",
    slug: "heo-sanghoon",
    title: "CEO & AI Research Lead (저서 5권 집필)",
  },
  {
    id: "2",
    tImg: timg2,
    name: "안수진 (An Sujin)",
    slug: "an-sujin",
    title: "Co-Founder & Sovereign Infra Lead",
  },
  {
    id: "3",
    tImg: timg3,
    name: "황영배 (Hwang Youngbae)",
    slug: "hwang-youngbae",
    title: "Co-Founder & Physical AI Robotics Lead",
  },
  {
    id: "4",
    tImg: timg4,
    name: "Atlas Sync Dual-Agent",
    slug: "atlas-agent-kernel",
    title: "PM & ENG Autonomous Mission Engine",
  },
];

export default Teams;
